<template>
  <div>
    <p class="filter-tit">
      {{ fieldname }}
    </p>
    <cube-input
      v-model="newValue"
      :placeholder="`${enterPlaceholder} ${fieldname}`"
      @change="handleChange"
    />
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    value: {
      type: [String, Array],
      default: () => { }
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    const { fieldtype } = this.data
    let value
    if (this.value) {
      if (fieldtype === 'phone' || fieldtype === 'email') {
        value = this.value.join(',')
      } else {
        value = this.value
      }
    }
    return {
      newValue: value
    }
  },
  computed: {
    fieldname () {
      return this.data.fieldname
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    }
  },
  methods: {
    handleChange (e) {
      const { fieldtype = '' } = this.data || {}
      let val = e.target.value
      if (fieldtype === 'phone' || fieldtype === 'email') {
        val = val.split(/[,，\s]+/)
      }
      this.$emit('change', val)
    }
  }
}
</script>

<style>
</style>
